import {
  BALLOT_MEETING_TIME_ID,
  BALLOT_MEETING_NAME_ID,
} from "./Constant";
import { useController, useForm } from "react-hook-form";
import { VotingMeetingFormType } from "./type";
import ControlInputBox from "./ControlInputBoxMeeting";
import Button from "@/components/Form/Button/Button";
import { MotifErrorMessage } from "@ey-xd/motif-react";
import {  useState } from "react";
import FormattedDatePicker from "@/components/FormattedDatePicker/FormattedDatePicker";
import { useCase } from "@/features/case/use-case";
import { useCreateMeetingMutation } from "../votingReducer";
import { useTranslation } from "react-i18next";

type CreateMeetingAllInputFieldsProps = {
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  isRefetch?: boolean;
  setIsRefetch: React.Dispatch<React.SetStateAction<boolean>>;
  setMeetingValue: any;
  meetingOptions?: any[];
};
export const CreateMeetingAllInputFields = ({
  setShowModal,
  setIsRefetch,
  setMeetingValue,
}: CreateMeetingAllInputFieldsProps) => {
  // const [dueDate, setDueDate] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const caseData = useCase();
let {t}=useTranslation()
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<VotingMeetingFormType>({
    defaultValues: {
      name: "",
      meetingDate: "",
    },
  });

   const { field:meetingDateFiled  } = useController({
      name: "meetingDate",
      control,
      rules: {
        required: {
          value: true,
          message: "",
        },
      },
    });
  const [createMeeting] = useCreateMeetingMutation();

  const onSubmit = async (formData: VotingMeetingFormType) => {
    let taskData = {
      caseId: caseData.caseId,
      name: formData.name,
      meetingDate:new Date(new Date(formData.meetingDate || new Date()).toLocaleString("en-US"))
      .toISOString()
      .substring(0, 10),
    };
    setIsLoading(true);
    const response = await createMeeting(taskData);
    if (response) {
      setShowModal(false);
      setIsLoading(false);
      setIsRefetch(true);
      //@ts-ignore
      setMeetingValue(response.data);
    } else {
      setShowModal(false);
      setIsLoading(false);
    }
  };
  // useEffect(() => {
  //   setValue(
  //     BALLOT_MEETING_TIME_ID,
  // new Date(new Date(dueDate || new Date()).toLocaleString("en-US"))
  //   .toISOString()
  //   .substring(0, 10)
  //   );
  // }, [dueDate, setValue]);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="motif-row" style={{ marginBottom: "20px" }}></div>
      <div className="motif-row">
        <div className="motif-col-md-4">
          <div className="form-field">
            <ControlInputBox
              name={BALLOT_MEETING_NAME_ID}
              control={control}
              required={true}
              isTextArea={false}
              label={"pages.voting.creditorVotes.createMeeting.meetingName"}
              showLabel={true}
            />
            {errors[BALLOT_MEETING_NAME_ID] &&
              errors[BALLOT_MEETING_NAME_ID].type === "required" && (
                <MotifErrorMessage>{t("pages.voting.creditorVotes.createMeeting.meetingName")}</MotifErrorMessage>
              )}
          </div>
        </div>
        <div className="motif-col-md-4">
          <div className="form-field">
            <div className="hidedatepicker">
              <ControlInputBox
                name={BALLOT_MEETING_TIME_ID}
                control={control}
                required={true}
                isTextArea={false}
                label={"pages.voting.creditorVotes.createMeeting.meetingDate"}
                showLabel={true}
              />
            </div>
            <FormattedDatePicker
              todayMark={true}
              //@ts-ignore
              value={meetingDateFiled.value}
              onChange={(value: any) => {
                meetingDateFiled.onChange(value);              }}
            />
            {errors[BALLOT_MEETING_TIME_ID] &&
              errors[BALLOT_MEETING_TIME_ID].type === "required" && (
                <MotifErrorMessage>{t("pages.voting.creditorVotes.createMeeting.meetingDateReq")}</MotifErrorMessage>
              )}
          </div>
        </div>
      </div>
      <div className="motif-row" style={{ marginBottom: "50px" }}></div>
      <Button
        label={t("global.globalActions.save")}
        variant="primary"
        className="motif-button"
        onClickHandler={handleSubmit(onSubmit)}
        type={isLoading ? "loader" : "submit"}
        disabled={isLoading}
      />
      <div className="motif-row" style={{ marginBottom: "150px" }}></div>
    </form>
  );
};
